<div class="close">
  <i-x class="close__icon" [ngClass]="{ '--light': lightColor }"></i-x>
</div>
